import React from 'react';

import card from './card';
import text from './text';
export namespace message {
    export function Welcome() {
        return (
            <card.Info>
                <text.Jumbo>
                    <strong>Welcome to Bridge</strong>
                </text.Jumbo>
                <text.Big>
                    Bridge allows you to update your SSH keys so you can connect to Beaker machines.
                </text.Big>
            </card.Info>
        );
    }
}

export default message;
